// extracted by mini-css-extract-plugin
export var block = "articles-aside-module--block--1lewY";
export var zzz = "articles-aside-module--zzz--3COz3";
export var blockTitle = "articles-aside-module--blockTitle--n--LW";
export var container = "articles-aside-module--container--oKuNj";
export var list = "articles-aside-module--list--1pZhD";